import * as Sentry from '@sentry/react';
import moment from 'moment-timezone';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import { dismissAppNotification, readAppNotifications } from '@/actions/appNotification';
import { RootState } from '@/store';

import Alert from '../Alert';
import Button from '../Button';
import Picture from '../Picture';
import s from './ExpertAcceptedInvitationNotification.module.scss';

// ENG-5506: stale "has joined" announcements older than this are hidden.
const MAX_AGE_DAYS = 365;

const ExpertAcceptedInvitationNotification = (props: any) => {
  const navigate = useNavigate();
  const { profile } = props.notification.payload;
  if (!profile) return null;

  useEffect(() => {
    const { notification, readAppNotifications } = props;
    if (!notification.read_at) {
      readAppNotifications(notification.id);
    }
  }, []);

  const handleCloseClick = () => {
    const { dismissAppNotification, notification } = props;
    dismissAppNotification(notification.id);
  };

  const handleRequestExpert = async () => {
    const { dismissAppNotification, notification } = props;
    try {
      await dismissAppNotification(notification.id);
    } catch (err) {
      // The click drops this promise, and a failed dismiss must not strand the user here.
      Sentry.captureException(err);
    }
    // ENG-5506: book under the team that owns the network the expert joined, so the
    // request's currency, account and booking-fee waiver follow it.
    const groupId = notification.payload.group?.id;
    const search = groupId ? `?${new URLSearchParams({ groupId })}` : '';
    navigate(`/profile/${notification.payload.profile.url_endpoint}/request${search}`);
  };

  return (
    <Alert preset="notification" onRequestClose={handleCloseClick}>
      <div className={s.notificationContents}>
        <div className={s.notificationPhoto}>
          <Picture user={profile} size={80} />
        </div>
        <div>
          <div className={s.notificationTitle}>
            <span className={s.expertName}>{profile.name}</span> has joined your expert network!
            You&rsquo;re now able to request calls without paying our platform booking fee.
          </div>
          <Button onClick={handleRequestExpert} size="medium">
            Request Expert
          </Button>
        </div>
      </div>
    </Alert>
  );
};

const ConnectedComponent = connect(undefined, {
  readAppNotifications,
  dismissAppNotification,
})(ExpertAcceptedInvitationNotification);

// @ts-expect-error TS(2339): Property 'filterNotifications' does not exist on t... Remove this comment to see the full error message
ConnectedComponent.filterNotifications = (state: RootState, notifications: any) => {
  // notification must have accessible expert to be accepted, and not be stale
  const cutoff = moment().subtract(MAX_AGE_DAYS, 'days');
  return notifications.filter(
    (n: any) => n.payload.profile && moment(n.created_at).isAfter(cutoff)
  );
};

export default ConnectedComponent;
